import colors from '../../utils/colors';
import type { AlertType } from './types';

export const ALERT_FONT_SIZE = 13;
export const ALERT_BORDER_RADIUS = 12;

export const ALERT_TEXT_COLOR = colors.neutral100;

export const colorsByType: Record<AlertType, string> = {
  error: colors.error100,
  success: colors.success100,
  info: colors.neutral100,
};

export const backgroundColorsByType: Record<AlertType, string> = {
  error: colors.error100,
  success: colors.success100,
  info: colors.lavander100,
};

export const namesByType: Record<AlertType, string> = {
  error: 'exclamation-circle',
  success: 'check-circle',
  info: 'exclamation-circle',
};
